import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  getDashboardContentsCall,
  getContentsByTypeCall,
  getMyContentsCall,
  getTagsCall,
  getContentsInProgressCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getDashboardContentsCall.saga,
  getContentsByTypeCall.saga,
  getMyContentsCall.saga,
  getTagsCall.saga,
  getContentsInProgressCall.saga,
];

export function* softSkillsContentsRootSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
